import { render } from "./Passport.vue?vue&type=template&id=5d5215c2&scoped=true"
import script from "./Passport.vue?vue&type=script&lang=js"
export * from "./Passport.vue?vue&type=script&lang=js"

import "./Passport.vue?vue&type=style&index=0&id=5d5215c2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5215c2"]])

export default __exports__